import Alpine from "alpinejs";

Alpine.data('quantitySelector', () => ({
  get variant() {
    return Alpine.store('variant');
  },
  min: 1,
  get max() {
    return this.variant.stock?.inventory_management === 'shopify' ? this.variant.stock?.quantity : 9999;
  },
  get increment() {
    return this.variant.quantity_rule?.increment || 1;
  },
  quantity: 1,
  incrementQuantity() {
    if (this.quantity < this.max) {
      this.quantity += this.increment;
    }
  },
  decrementQuantity() {
    if (this.quantity > this.min) {
      this.quantity -= this.increment;
    }
  },
}));